import React, { useEffect, useState } from "react";
import { Layout, Row, Col, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FetchLandingPageAction } from "../../redux/action/LandingPageAction";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { appConfig } from "../../mocks/appConfig";
import { appConfigUAT } from "../../mocks/appConfig-uat";
import LandingPageHeader from "../../components/Header/LandingPageHeader";
import MainHeader from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import { useAuth } from "../../utils/auth/useAuth";
import InfoIcon from "../../components/Icons/InfoIcon";
import { LoadingSpinner, Card, Switcher } from "pepsico-ds";
// import "./Landing.scss";
import "../../components/Layout/Layout.scss";
import LMSBanner from '../../assets/LMSBanner.svg'
import { localStoreKeys } from '../../constants/localStoreKeys';
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import SingleSelectDropdown from '../../components/Dropdown/SingleSelectDropdown';
import MultiSelectDropdown from '../../components/Dropdown/MultiSelectDropdown';
import NpsLineBarChart from "../../components/Charts/NPSAdminChart/NpsLineBarChart";
import CommonTable from "../../components/Table/CommonTable";
import { getDropdownOptions, getSectors, getBusinessUnitsBySector, getCategoriesBySectorAndBusinessUnit, getCategoriesLevel1, getYears } from '../KPIOverview/KpiUtils';
import { formatIntoDropdownData, getMonthsAdjustedForCurrentDate, getCurrentMonthObject, getMonthsWithYearWithMaxDate, getToDateOptionsWithMaxDate, call7DaysNpsLogic } from '../../utils/utils';
import { allCategoryL0NPS } from '../../mocks/userJson';
import { FetchNpsAdminAction } from "../../redux/action/NpsAdminAction";
import LegendList from "../../components/Charts/Legend/LegendList";
import NoData from "../../components/NoData/NoData";
import NpsBarChart from "../../components/Charts/NPSAdminChart/NpsBarChart";
import { useToast } from '../../components/Toast/ToastContext';
import { Icon } from 'pepsico-ds'
import { useTour } from '../../routes/JoyrideProvide'
import { useLoginEffects } from "../WalkmeTour/UseLoginEffects";

const { Content } = Layout;

let coverageColumns = [
    { columnKey: 'a', header: '' },
    { columnKey: 'date', header: "Date", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'userName', header: "User Name", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'sector', header: "Sector", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'bu', header: "BU", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'l0Category', header: "Category L0", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'l1Category', header: "Category L1", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'npsScore', header: "Score", size: 90, minSize: 90, maxSize: 140,
      cellData: (ctx) => {
        const tdClassName = ctx.row.original.npsScore == '9' || ctx.row.original.npsScore == '10' ? "nps-td-green nps-td-width35": ctx.row.original.npsScore <= '6' ? "nps-td-red nps-td-width35":"nps-td-yellow nps-td-width35"
        return <div className={tdClassName}><span>{ctx.row.original.npsScore}</span></div>
        },
    },
    { columnKey: 'npsCategory', header: "Category", size: 90, minSize: 90, maxSize: 140,
      cellData: (ctx) => {
            const tdClassName = ctx.row.original.npsCategory=="PROMOTER" ? "nps-td-green": ctx.row.original.npsCategory=="DETRACTOR" ? "nps-td-red": ctx.row.original.npsCategory=="PASSIVE" ? "nps-td-yellow": ""
            return <div className={tdClassName}>{ctx.row.original.npsCategory}</div>
            },
    },
    // { columnKey: 'feedback1', header: "Feedback", size: 90, minSize: 90, maxSize: 140 },
    // { columnKey: 'feedback2', header: "Feedback 2", size: 90, minSize: 90, maxSize: 140 },
    { columnKey: 'feedback1', header: () => <span style={{ display: "flex" }}><span style={{ marginRight: "5px" }}>FEEDBACK</span>
                                                <InfoIcon text="What is the primary reason for your score?" direction="left"/>
                                            </span>,
      size: 90, minSize: 90, maxSize: 140,
        cellData: (ctx) => {
            const feedback = ctx.row.original.feedback1;
            return (
                <div>
                    {feedback.length > 15 ? (
                        <span title={feedback}>{feedback.slice(0, 15)}...</span>
                    ) : (
                        feedback
                    )}
                </div>
            );
        },
    },
    { columnKey: 'feedback2', header: () => <span style={{ display: "flex" }}><span style={{ marginRight: "5px" }}>FEEDBACK 2</span>
                                                <InfoIcon text="What can we do to improve your experience?"  direction="left"/>
                                            </span>,
    size: 90, minSize: 90, maxSize: 140,
        cellData: (ctx) => {
            const feedback = ctx.row.original.feedback2;
            return (
                <div>
                    {feedback.length > 15 ? (
                        <span title={feedback}>{feedback.slice(0, 15)}...</span>
                    ) : (
                        feedback
                    )}
                </div>
            );
        },
    },
];





function NpsAdminDashboard() {
	const dispatch = useDispatch();
	const { authState } = useAuth();
	const [userInfo, setUserInfo] = useState({});
    const isLoading = useSelector((state) => state?.loader?.isLoading);
	
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const [isUserDataFetched, setIsUserDataFetched] = useState(false)
    const [loader, setLoader] = useState(true)
    const [userInfoByRole, setUserInfoByRole] = useState({})
    const [allRoles, setAllRoles] = useState([])
    const [rolesSelected, setRolesSelected] = useState([])
    const [sectorSelected, setSectorSelected] = useState([])
    const [sectors, setSectors] = useState([])
    const [businessUnits, setBusinessUnits] = useState([])
    const [businessUnitSelected, setBusinessUnitSelected] = useState([])
    const [categoryL0Selected, setCategoryL0Selected] = useState([])
    const [categoriesLevel0, setCategoriesLevel0] = useState([])
    const [categoriesLevel1, setCategoriesLevel1] = useState([])
    const [categoryL1Selected, setCategoryL1Selected] = useState([])
    const userData = useSelector((state) => state.getLandingPageReducer);

    useLoginEffects(userData)
    
    const [minYear, setMinYear] = useState("")
    const [maxYear, setMaxYear] = useState("")
    const [defaultYear, setDefaultYear] = useState("")
    const [entireMonthList, setEntireMonthList] = useState([])
    const [fromDates, setFromDates] = useState([])
    const [fromDateSelected, setFromDateSelected] = useState("")
    const [toDates, setToDates] = useState([])
    const [toDateSelected, setToDateSelected] = useState("")
    const [switcherIndex, setSwitcherIndex] = useState(0)
    const hasRendered = React.useRef(false);
    const { showToast } = useToast();
    
    const npsAdminPageData = useSelector((state) => state.getNpsAdminReducer);

    const npsAdminheaderKPIData = npsAdminPageData?.headerDetailsDto

    const npsAdminLineBarChartData = npsAdminPageData?.trendGraphDto
    
    const npsAdminRegionNpsChartData = npsAdminPageData?.npsSegmentWiseGraphDto

	const npsAdminTableData = npsAdminPageData?.npsTableView

    const { startTour } = useTour();

	useEffect(() => {
		async function fetchUserInfo() {
			const user = await getUserClaims();
			if (user) {
				setUserInfo(user);
				dispatch(FetchLandingPageAction(user))
				setIsUserDataFetched(true)
			}
		}
		fetchUserInfo();
	}, []);

    /* istanbul ignore next */
    useEffect(()=>{
        if (!hasRendered.current) {
            // Skip the initial render
            hasRendered.current = true;
            return;
        }
        reloadNPSData({ switcherIdx: switcherIndex })
    },[switcherIndex])

    /* istanbul ignore next */
    useEffect(() => {
        if (isUserDataFetched && userData && userData.type === "SUCCESS_LANDING_PAGE_ACTION") {

            // dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // // 7 days NPS logic
            // const now = Date.now();
            // const responseDate = new Date(userData?.mostRecentDate).getTime();
            // const diffInMs = Math.abs(now - responseDate);
            // const daysDiff = diffInMs / (1000 * 60 * 60 * 24);

            // if (daysDiff >= 7) {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // } else {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: true }))
            // }
            // 7 days NPS logic
            call7DaysNpsLogic(dispatch, userData)
            
            const roles = getDropdownOptions(userData?.npsRoles)
            setAllRoles(roles)
            setRolesSelected(roles)

            const getUserInfoByRole = userData?.npsRoleDetail?.filter(item => item.role === "ADMIN")?.[0]
            setUserInfoByRole(getUserInfoByRole)
            
            if (getUserInfoByRole?.roleDetail) {
                const sectors = getSectors(getUserInfoByRole?.roleDetail);
                setSectors(sectors)
                setSectorSelected(sectors)

                let sectorsToInclude = sectors?.map(item => (item.displayText))
                const BUs = getBusinessUnitsBySector(getUserInfoByRole?.roleDetail, sectorsToInclude);
                setBusinessUnits(BUs)
                setBusinessUnitSelected(BUs)

                let businessUnitsToInclude = BUs?.map(item => (item.displayText))
                const tempCategories = getCategoriesBySectorAndBusinessUnit(getUserInfoByRole?.roleDetail, sectorsToInclude, businessUnitsToInclude)
                let categoriesToInclude = tempCategories.map(item => (item.displayText))
                const l0dropdown = formatIntoDropdownData(categoriesToInclude, allCategoryL0NPS)
                setCategoriesLevel0(l0dropdown)
                setCategoryL0Selected(l0dropdown)

                const tempCategoriesLevel1 = getCategoriesLevel1(getUserInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude)
                setCategoriesLevel1(tempCategoriesLevel1)
                setCategoryL1Selected(tempCategoriesLevel1)
                
                const allYears = getYears(userData.year);
                const minYr = allYears[allYears.length - 1]?.displayText;
                const maxYr = allYears[0]?.displayText;
                const defaultYr = maxYr;
                setMaxYear(maxYr);
                setMinYear(minYr);
                setDefaultYear(defaultYr)
                
                setEntireMonthList(getMonthsAdjustedForCurrentDate(minYr, maxYr));
                const maxDateObject = getCurrentMonthObject("NPSAdmin");
                const minDateText = userData?.npsMinYearMonth;
                const fromDate = getMonthsWithYearWithMaxDate(allYears, maxDateObject, minDateText);
                
                setFromDates(fromDate)
                const fromDateMonth =  fromDate?.find(item => item?.displayText === `Dec ${defaultYr}`) 
                                        ? maxDateObject?.maxYearMonth?.split(" ")?.[0] : 'Jan'
                // const tempFromDate = fromDate.filter((item) => {
                //     return item.displayText === (fromDateMonth + ' ' + defaultYr);
                // })
                const tempFromDate = [fromDate?.[0]]
                setFromDateSelected(tempFromDate);

                let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]);
                let maxYearMonth = maxDateObject?.maxYearMonth;
                let tempToDate = fromDate.filter((item) => {
                    let temp = fromDate[fromDate.length - 1]?.displayText;
    
                    let currentLastMonth = Number(defaultYr) < objectYear
                        ? "Dec " + defaultYr
                        : maxYearMonth;
    
                    return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
                });
                const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.['displayText'], maxDateObject);
                
                setToDates(toDateOptions);
                setToDateSelected(tempToDate);
                reloadNPSData({ roles, sectors, bus: BUs, l0: l0dropdown, l1: tempCategoriesLevel1, fromDate: tempFromDate, toDate: tempToDate, switcherIdx: 0 })
                
            }

        }
    }, [userData])
    
    /* istanbul ignore next */
    const onRoleChange = (val) => {
        if (val && val.length > 0) {
            setRolesSelected(val)
            reloadNPSData({ roles: val })
        } else {
            if (val && val.length === 0) {
                setRolesSelected([])
                message.warning("At least one view is required")
            }
        }
    } 
    
    /* istanbul ignore next */
    const onSectorChange = (val) => {
        if (val && val.length > 0) {
            setSectorSelected(val)

            let sectorsToInclude = val?.map(item => (item.displayText))
            const BUs = getBusinessUnitsBySector(userInfoByRole?.roleDetail, sectorsToInclude);
            setBusinessUnits(BUs)
            setBusinessUnitSelected(BUs)
            reloadNPSData({ sectors: val, bus: BUs })

        } else {
            if (val && val.length === 0) {
                setSectorSelected([])
                setBusinessUnitSelected([])
                message.warning("At least one sector is required")
            }
        }
    }
    
    /* istanbul ignore next */
    const onBusinessUnitChange = (val) => {
        if (val && val.length > 0) {
            setBusinessUnitSelected(val)
            reloadNPSData({ bus: val })
        } else {
            if (val && val.length === 0) {
                setBusinessUnitSelected([])
                message.warning("At least one BU is required")
            }
        }
    }
    
    /* istanbul ignore next */
    const onCategoryLevel0Change = (val) => {
        if (val && val.length > 0) {
            setCategoryL0Selected(val)
            let sectorsToInclude = sectorSelected?.map(item => (item.displayText))
            let businessUnitsToInclude = businessUnitSelected?.map(item => (item.displayText))
            let categoriesToInclude = val?.map(item => (item.displayText))

            const tempCategoriesLevel1 = getCategoriesLevel1(userInfoByRole?.roleDetail, categoriesToInclude, sectorsToInclude, businessUnitsToInclude)

            setCategoriesLevel1(tempCategoriesLevel1)
            setCategoryL1Selected(tempCategoriesLevel1)
            reloadNPSData({ l0: val, l1: tempCategoriesLevel1 })
        } else {
            if (val && val.length === 0) {
                setCategoryL0Selected([])
                setCategoryL1Selected([])
                message.warning("At least one category L0 is required")
            }
        }
    }
    
    /* istanbul ignore next */
    const onCategoryLevel1Change = (val) => {
        if (val && val.length > 0) {
            setCategoryL1Selected(val)
            reloadNPSData({ l1: val })
        } else {
            if (val && val.length === 0) {
                setCategoryL1Selected([])
                message.warning("At least one category L1 is required")
            }
        }
    }
    
    /* istanbul ignore next */
    const onFromDateChange = (val) => {
        if (val && val.length > 0) {
            setFromDateSelected(val)
            const maxDateObject = getCurrentMonthObject("NPSAdmin");
            const toDateOptions1 = getToDateOptionsWithMaxDate(val[0]['displayText'], maxDateObject);
            setToDates(toDateOptions1);

            let tempY = val[0]['displayText']?.split(" ")?.[1]
            const date1 = new Date(val[0]['displayText']);
            const date2 = new Date(toDateSelected?.[0]?.['displayText']);
            const date2Year = date2?.getFullYear();
            const toDateMonth = months[date2?.getMonth()];;

            const tempToDate = toDateOptions1?.filter((item) => { // CHANGED
                return item.displayText === ('Dec ' + tempY);
            })

            const customTempToDate = toDateOptions1?.filter((item) => { // CHANGED
                return item.displayText === (`${toDateMonth} ` + date2Year);
            })
            changeToDateOptions(val[0])

            if (!isNaN(date1.getTime()) && !isNaN(date2?.getTime())) {
                if (date1 <= date2) {
                    setToDateSelected(customTempToDate);
                    reloadNPSData({ fromDate: val, toDate: customTempToDate })
                } else {
                    setToDateSelected(tempToDate);
                    reloadNPSData({ fromDate: val, toDate: tempToDate })
                }
            } else {
                reloadNPSData({ fromDate: val })
            }
        }
    }
    
    /* istanbul ignore next */
    const onToDateChange = (val) => {
        if (val && val.length > 0) {
            setToDateSelected(val)
            changeFromDateOptions(val[0]);
            reloadNPSData({ toDate: val })
        } else {
            message.warning("To Date is not selected")
        }
    }

    
    /* istanbul ignore next */
    const changeToDateOptions = (fromDateMonthSelected) => {
        const toDateSelected1 = fromDateMonthSelected.displayText;
        const fromDate = new Date(toDateSelected1);
        const filteredMonths = entireMonthList.filter((month) => {
            const monthDate = new Date(month.value);
            return monthDate >= fromDate;
        });
        setToDates(filteredMonths);
    };

    
    /* istanbul ignore next */
    const changeFromDateOptions = (toDateMonthSelected) => {
        const toDateSelected = toDateMonthSelected.displayText;
        const maxDate = new Date(toDateSelected);

        const allYears = getYears(userData.year);
        const minYr = allYears[allYears.length - 1]?.displayText;
        const maxYr = allYears[0]?.displayText;
        const defaultYr = maxYr;
        setMaxYear(maxYr);
        setMinYear(minYr);
        setDefaultYear(defaultYr)
        
        setEntireMonthList(getMonthsAdjustedForCurrentDate(minYr, maxYr));
        const maxDateObject = getCurrentMonthObject("NPSAdmin");
        const minDateText = userData?.npsMinYearMonth;
        const fromDateList = getMonthsWithYearWithMaxDate(allYears, maxDateObject, minDateText);

        const filteredMonths = fromDateList.filter((month) => {
            const monthDate = new Date(month.value);
            return monthDate <= maxDate;
        });
        filteredMonths.push(toDateMonthSelected);
        filteredMonths.sort((a, b) => new Date(a.value) - new Date(b.value));
        
        setFromDates(filteredMonths)
    }

    /* istanbul ignore next */
    const showWarningMessage = (message) => {
        showToast('warning', message, {
            icon: <Icon alt="" icon="warning_amber" size="medium" />
        });

    }

    /* istanbul ignore next */
    const reloadNPSData = ({
        roles = rolesSelected,
        sectors = sectorSelected,
        bus = businessUnitSelected,
        l0 = categoryL0Selected,
        l1 = categoryL1Selected,
        fromDate = fromDateSelected,
        toDate = toDateSelected,
        switcherIdx = switcherIndex
    } = {}) => {
        const rolesArr = roles?.map(item => item.displayText);
        const sectorsArr = sectors?.map(item => item.displayText);
        const busArr = bus?.map(item => item.displayText);
        const l0Arr = l0?.map(item => item.displayText);
        const l1Arr = l1?.map(item => item.displayText);
        const fromDateStr = fromDate?.map(item => item.value).toString();
        const toDateStr = toDate?.map(item => item.value).toString();

        const requestObj = {
            "fromDate": fromDateStr,
            "toDate": toDateStr,
            "userPersona": rolesArr,
            "sector": sectorsArr,
            "bu": busArr,
            "l0Category": l0Arr,
            "l1Category": l1Arr,
            "isPHUsersEnabled": switcherIdx !== 0
        };

        if (rolesArr?.length > 0 && sectorsArr?.length > 0 && busArr?.length > 0 && l0Arr?.length > 0 && l1Arr?.length > 0) {
            dispatch(FetchNpsAdminAction(requestObj));
            setLoader(false);
        } else {
            message.warning("Please select required filters");
        }
        setSelectedDropDownValue([dropdownValue[0]]);
    }

    const lineChartLegends= [
        {
            "name": "Number of Response",
            "color": "#0078A7"
        },
        {
            "name": "NPS Score",
            "color": "#B05788"
        },
        ]

        const columnsToInclude = [
            "DATE",
            "USER NAME",
            "SECTOR",
            "BU",
            "CATEGORY L0",
            "CATEGORY L1",
            "SCORE",
            "CATEGORY",
            "FEEDBACK",
            "FEEDBACK 2"
        ]

        const columnMapping = {
            "date": 'DATE',
            "userName": 'USER NAME',
            "sector": "SECTOR",
            "bu": "BU",
            "l0Category": "CATEGORY L0",
            "l1Category": "CATEGORY L1",
            'npsScore': 'SCORE',
            'npsCategory': 'CATEGORY',
            'feedback1': 'FEEDBACK',
            'feedback2': 'FEEDBACK 2'
          }

          const dropdownValue = [
            { displayText: 'User Persona', id: 1, value: 'npsScoreByUserPersona' },
            { displayText: 'Category', id: 2, value: 'npsScoreByL1Category' },
            { displayText: 'Sector', id: 3, value: 'npsScoreBySector' },
            { displayText: 'BU', id: 4, value: 'npsScoreByBu' },
          ]
          const [selectedDropDownValue, setSelectedDropDownValue] = useState([dropdownValue[0]]);
          // const [npsChartData, setNpsChartData] = useState(npsAdminRegionNpsChartData);
          const [chartValue, setChartValue] = useState(npsAdminRegionNpsChartData?.npsScoreByUserPersona || []);
          
          useEffect(() => {
            if (npsAdminRegionNpsChartData?.npsScoreByUserPersona) {
              
              setChartValue(npsAdminRegionNpsChartData.npsScoreByUserPersona);
            }
          }, [npsAdminRegionNpsChartData]);

          /* istanbul ignore next */
            //   useEffect(()=>{
            //     console.log("hideTour: ", localStorage.getItem('hideTour'))
            //     const hideTour = localStorage.getItem('hideTour') === 'true';
            //     if (userData?.isWalkMeEnabled && !hideTour) {
            //     startTour();
            //     }
                
            // },[userData])
              /* istanbul ignore next */
            //  useEffect(() => {
            //     const shouldAnimate = sessionStorage.getItem("showLoginAnimation");
          
            //     if (shouldAnimate !== "true") return;
          
            //     const observer = new MutationObserver(() => {
            //         const element = document.querySelector(".rocket-wrapper");
          
            //         if (element) {
            //         element.classList.add("animate-blue");
          
            //         element.addEventListener(
            //             "animationend",
            //             () => {
            //             element.classList.remove("animate-blue");
            //             },
            //             { once: true }
            //         );
            //         sessionStorage.removeItem("showLoginAnimation");
            //         observer.disconnect(); // stop observing
            //         }
            //     });
          
            //     observer.observe(document.body, {
            //         childList: true,
            //         subtree: true,
            //     });
          
            //     return () => observer.disconnect();
            // }, []);
          /* istanbul ignore next */
          const onDropdownChange = (val) => {
            const dynamicVal = val[0]?.value;
            if (npsAdminRegionNpsChartData && dynamicVal && npsAdminRegionNpsChartData[dynamicVal] && Array.isArray(npsAdminRegionNpsChartData[dynamicVal])) {
              setChartValue(npsAdminRegionNpsChartData[dynamicVal]);
            } else {
              setChartValue([]);
            }
            setSelectedDropDownValue(val);
          };
        /* istanbul ignore next */
        const getNpsColor = (value) => {
            if (value < 0) return '#D20000';    // Red
            else if (value >= 0 && value <=10) return '#ff891c';    // Orange
            else if (value >= 10 && value <=30 ) return '#FFB933';    // Yellow
            else if (value >= 30 && value <=50 ) return '#66CC66';    // light green // #B3DACB
            return '#008251';                     // Dark Green
          };

	if(authState?.isAuthenticated){
		return(
			<>
                <Layout>
					{/* <MainHeader /> */}
					<div style={{ display: "flex" }}>
						{/* <Sidebar /> */}
						{/* background: #F3F7FD */}
						<Content style={{ padding: "0 30px 30px 100px", background: "#D7E5F8", paddingTop: 20, minHeight:"125vh" }}>
							{Object.keys(userInfo).length === 0 ? (
								<div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "calc(100vh - 64px)" }}>
									<LoadingSpinner size={{ height: "80px", width: "80px" }} />
								</div>
							) : (
								<>
                                    <div className="landing_page_title" style={{marginBottom: '15px'}}> NPS Dashboard </div>
									<Card
                                        // border
                                        icon=""
                                        ellipsis={false}
                                        style={{ borderRadius: '12px' }}
                                    >
                                    <Row gutter={[20, 20]} style={{width: '100%'}}>
                                        <div>
                                            <Switcher
                                            className=""
                                            items={[
                                                {
                                                label: 'All Users',
                                                leadingIcon: 'edit',
                                                showLeadingIcon: false,
                                                style: {width: '100%', display: 'flex', justifyContent: 'center'}
                                                },
                                                {
                                                label: 'Procurement Users',
                                                leadingIcon: 'edit',
                                                showLeadingIcon: false,
                                                style: {width: '100%', display: 'flex', justifyContent: 'center'}
                                                }
                                            ]}
                                            selectedItemIndex={switcherIndex}
                                            onUpdate= {(val) => {
                                                setSwitcherIndex(val)
                                            }}
                                            style={{ display: 'flex', justifyContent: 'flex-start', width: '30rem' }}
                                            />
                                            <div className="kpi-card-title-nps" style={{marginTop: '20px'}}>
                                                {switcherIndex == 0 ? 'All Users' : 'Procurement Hub Users'}
                                            </div>

                                        </div>
                                        

                                    </Row>
                                    <Row gutter={[20, 20]}>
                                        <Col flex="1">

                                            <MultiSelectDropdown placeholder="Views" label="User Persona" 
                                                className={"ph-role-dropdown buy-con-dropdown"}
                                                childList={allRoles} 
                                                selectedValue={rolesSelected} 
                                                setSelectedValue={onRoleChange}
                                             />
                                        </Col>
                                        <Col flex="1">

                                            <MultiSelectDropdown placeholder="Sectors" label="Sector" 
                                                childList={sectors} 
                                                selectedValue={sectorSelected} 
                                                setSelectedValue={onSectorChange} 
                                            />
                                        </Col>
                                        <Col flex="1">

                                            <MultiSelectDropdown placeholder="BUs" label="Business Unit / Market" 
                                                childList={businessUnits} selectedValue={businessUnitSelected} 
                                                setSelectedValue={onBusinessUnitChange}
                                             />
                                        </Col>
                                        <Col flex="1">

                                            <MultiSelectDropdown placeholder="Categories L0" label="Category L0" 
                                                childList={categoriesLevel0} selectedValue={categoryL0Selected} 
                                                setSelectedValue={onCategoryLevel0Change} 
                                            />
                                        </Col>
                                        <Col flex="1">

                                            <MultiSelectDropdown placeholder="Categories L1" label="Category L1" 
                                                childList={categoriesLevel1} selectedValue={categoryL1Selected} 
                                                setSelectedValue={onCategoryLevel1Change} 
                                            />
                                        </Col>
                                        <Col flex="1">

                                            <SingleSelectDropdown className='buy-con-dropdown-modal' label="From Date" 
                                                childList={fromDates} 
                                                selectedValue={fromDateSelected} setSelectedValue={onFromDateChange} 
                                            />
                                        </Col>

                                        <Col flex="1">

                                            <SingleSelectDropdown className='buy-con-dropdown-modal' label="To Date" 
                                                childList={toDates} selectedValue={toDateSelected} setSelectedValue={onToDateChange} 
                                            />
                                        </Col>

                            
                                    </Row>
                                    {
                                    isLoading || loader || !isUserDataFetched ? (
                                        <>
                                            {/* <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "calc(100vh - 64px)" }}>
                                                <LoadingSpinner size={{ height: "80px", width: "80px" }} />
                                            </div> */}
                                        </>
                                    ) : (
                                        <>
                                            <div style={{ marginTop: 10, marginBottom: 10, display: 'flex', justifyContent: 'flex-start', width: '100%', flexDirection: "row" }}>
                                    <Row gutter={[20, 20]} justify="start" style={{ width: "100%" }}>
                                        {
                                            npsAdminheaderKPIData ? (
                                                <>
                                                    <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                            <div >
                                                
                                                <div className="spend-modal-total-supplier" style={{color: getNpsColor(npsAdminheaderKPIData?.npsScore)}}>{npsAdminheaderKPIData?.npsScore}</div>
                                                <div  style={{color: '#616161', fontSize: '18px', fontWeight: '700'}}>NPS Score 
                                                <span style={{marginLeft: '8px', position: 'relative',top: '2px'}}>
                                                    <InfoIcon text="NPS Score = (# of Promoters - # of Detractors) / (# of Total Responses) * 100" direction="right"/>
                                                </span></div>
                                                
                                                <div className='spend-modal-manage-spend'>{npsAdminheaderKPIData?.userCount} Distinct Users | {npsAdminheaderKPIData?.totalResponses} Total Responses </div>
                                                
                                            </div>
                                        </Col>

                                        <div className="modal-divider-verticle" />
                                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                            <div >
                                            
                                                <div className="spend-modal-total-supplier" style={{color: '#D20000 '}}>{npsAdminheaderKPIData?.detractorsPercentage}</div>
                                                <div className="kpi-card-title-nps" style={{color: '#616161'}}>Detractors <span className='spend-modal-manage-spend'>(1-6) </span></div>
                                                <div className='spend-modal-manage-spend'>{npsAdminheaderKPIData?.detractorsResponsesCount} Total Responses</div>
                                            </div>
                                        </Col>

                                        <div className="modal-divider-verticle" />
                                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                            <div >
                                                
                                                <div className="spend-modal-total-supplier"  style={{color: '#FFB933'}}>{npsAdminheaderKPIData?.passivePercentage}</div>
                                                <div className="kpi-card-title-nps" style={{color: '#616161'}}>Passive <span className='spend-modal-manage-spend'>(7-8) </span></div>
                                                <div className='spend-modal-manage-spend'>{npsAdminheaderKPIData?.passiveResponsesCount} Total Responses</div>
                                            </div>
                                        </Col>
                                        <div className="modal-divider-verticle" />
                                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                                            <div >
                                                
                                                <div className="spend-modal-total-supplier" style={{color: "#008251"}}>{npsAdminheaderKPIData?.promotersPercentage}</div>
                                                <div className="kpi-card-title-nps" style={{color: '#616161'}}>Promoters <span className='spend-modal-manage-spend'>(9-10) </span></div>
                                                <div className='spend-modal-manage-spend' style={{ display: "flex" }}><span style={{ marginRight: "4px" }}>{npsAdminheaderKPIData?.promotersResponsesCount} Total Responses</span> </div>
                                            </div>
                                        </Col>
                                                </>
                                            ): <></> 
                                        }
                                        
                                        
                                    </Row>
                                
                                </div>
                                        </>
                                    )
                                }
                        
                        </Card>
                        {
                            isLoading || loader || !isUserDataFetched ? (
                                <>
                                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "calc(100vh - 64px)" }}>
                                                    <LoadingSpinner size={{ height: "80px", width: "80px" }} />
                                                </div>
                                    
                                </>
                            ) : (
                                <>
                                    <div className="npsAdmin-cardLayout">
                                    <div className="kpi-card-title-nps" style={{marginBottom: '20px'}}>NPS Score - Summary of Responses and Trend</div>
                                    {
                                        npsAdminLineBarChartData && Object.keys(npsAdminLineBarChartData).some(key => Array.isArray(npsAdminLineBarChartData[key]) && npsAdminLineBarChartData[key].length > 0) ? (
                                            <>
                                        <NpsLineBarChart npsAdminLineBarChartData={npsAdminLineBarChartData}/>
                                        <LegendList legends={lineChartLegends} style={{marginTop: '5px'}}/>
                                    </>
                                ) : <NoData />
                            }
                                
                        </div>
                        <div className="npsAdmin-cardLayout">
                        <div className="kpi-card-title-nps" style={{marginBottom: '20px'}}>NPS Score by User Persona, Category, Sector, BU</div>
                            {
                                npsAdminRegionNpsChartData && Object.keys(npsAdminRegionNpsChartData).some(key => Array.isArray(npsAdminRegionNpsChartData[key]) && npsAdminRegionNpsChartData[key].length > 0) ? (
                                    <>
                                    <div 
                                        style={{ width: '9rem', float: 'right', position: 'relative', bottom: '3rem' }}
                                        >
                                            <SingleSelectDropdown 
                                            className='buy-con-dropdown-modal' 
                                            childList={dropdownValue} label="" 
                                            selectedValue={selectedDropDownValue}
                                            setSelectedValue={onDropdownChange} 
                                            />
                                    </div>
                                
                                    <NpsBarChart data={chartValue}/>
                                    </>
                                ) : <NoData />
                            }
                                
                        </div>
                        <div className="npsAdmin-cardLayout">
                            {
                                npsAdminTableData && npsAdminTableData?.length > 0 ? (
                                    <>
                                        <div className="ph-table-wrapper">
                                            <CommonTable 
                                            // className="compass-category-table" 
                                            className="nps-admin-table"
                                            data={npsAdminTableData} 
                                            columns={coverageColumns} 
                                            tableHeader={"Response Details"} 
                                            enableSorting={true} 
                                            columnsToInclude={columnsToInclude} 
                                            columnMapping={columnMapping}
                                            tableName={'RESPONSE DETAILS'}
                                            />
                                        </div>
                                    </> 
                                ): <NoData />
                            }
                            
                        </div>
                                </>
                            )
                        }
                                </>
							)}
						</Content>
					</div>
                    
				</Layout>
				</>
		)
	}
}

export default NpsAdminDashboard;